'use strict';

if (!Amisco) {
    var Amisco = {};
}

Amisco.Common = {
    Lang: $('html').attr('lang').substring(0, 2)
};

Amisco.Common.manageAnchor = function (anchor) {
    var tab = $('[data-target="' + anchor + '"]');

    // If the anchor is corresponding to a tab, trigger click on the tab
    if (tab.length > 0) {
        tab.trigger('click');
    } else {
        Amisco.Common.smoothScrollToAnchor(anchor);

        // Add the hash of the anchor in the URL
        history.replaceState(null, null, anchor);
    }
};

Amisco.Common.smoothScrollToAnchor = function (anchor) {
    var anchor = $(anchor);

    if (anchor.length > 0) {
        var headerHeight = $('.js-header').outerHeight();

        $('html, body').animate({ scrollTop: anchor.offset().top - headerHeight }, 1000);
    }
};

Amisco.Common.initSlick = function () {
    $('[data-slick]').slick({
        arrows: false,
        fade: true
    });

    $('[data-slick-ref]').click(function () {
        var ref = $(this).attr('data-slick-ref');
        var goTo = $(this).attr('data-slick-go');

        $('[data-slick-id="' + ref + '"]').slick('slickGoTo', goTo);
        $('[data-slick-ref="' + ref + '"]').removeClass("is-active");
        $(this).addClass("is-active");
    });
};

Amisco.Common.initTabs = function () {
    $('[data-tab-control]').click(function () {
        var tabGroup = $(this).attr('data-tab-group');
        var tabToGo = $(this).attr('data-tab-control');

        $('[data-tab-group="' + tabGroup + '"]').removeClass('is-active');

        $(this).addClass('is-active');
        $('[data-tab-group="' + tabGroup + '"][data-tab="' + tabToGo + '"]').addClass('is-active');
    });
};

Amisco.Common.HeaderMask = function (isVisible) {
    var headerMask = $('.js-header-mask');

    if (isVisible) {
        headerMask.show();
    } else {
        headerMask.hide();
    }
};

Amisco.Common.HideSubmenus = function () {
    $('.menu-item-has-children .sub-menu').slideUp(250);
};

Amisco.Common.initMobileNav = function () {
    var mobileSpeed = 250;
    var mobileMenu = $('.js-menu-mobile');
    var mobileMenuBtn = $('.js-menu-mobile-btn ');
    var mobileSearch = $('.js-mobile-search-wrapper');
    var mobileSearchInput = $('.js-mobile-search-input');
    var mobileSearchBtn = $('.js-mobile-search-toggle');
    var mobileSearchClose = $('.js-mobile-search-close');

    mobileMenu.find('.sub-menu').slideUp();

    mobileMenu.find('.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        var currentSubMenu = $(this).next('.sub-menu');
        $(this).toggleClass('is-open');

        if ($(this).hasClass('is-open')) {
            currentSubMenu.slideDown(mobileSpeed);
        } else {
            currentSubMenu.slideUp(mobileSpeed);
        }
    });

    mobileMenuBtn.on('click', function (e) {
        e.preventDefault();
        mobileMenu.stop().slideToggle(mobileSpeed);
        mobileSearch.slideUp(mobileSpeed);
    });

    mobileSearchBtn.on('click', function (e) {
        e.preventDefault();
        mobileMenu.slideUp(mobileSpeed);
        mobileSearch.slideToggle(mobileSpeed, function () {
            if (mobileSearch.is(':visible')) {
                mobileSearchInput.focus();
            }
        });
    });

    mobileSearchClose.on('click', function (e) {
        e.preventDefault();
        mobileSearch.slideUp(mobileSpeed);
    });
};

Amisco.Common.init = function () {
    $('iframe[src*="youtube"]').parent().fitVids();

    $('.js-go-to-anchor').on('click', function (e) {
        return Amisco.Common.manageAnchor(this.hash);
    });

    Amisco.Common.initSlick();
    Amisco.Common.initTabs();

    $('.js-search-toggle').click(function () {
        var searchWrapper = $('.js-search-wrapper');

        searchWrapper.slideToggle(250, function () {
            if (searchWrapper.is(':visible')) {
                $('.js-search-input').focus();
            }
        });
    });

    $('.js-search-close').click(function () {
        $('.js-search-wrapper').slideUp(250);
    });

    // Init print button
    $('.js-btn-print').on('click', function () {
        window.print();
    });

    $('.header .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        $(this).next('.sub-menu').slideToggle(250, function () {
            if ($(this).is(':visible')) {
                Amisco.Common.HeaderMask(true);
            } else {
                Amisco.Common.HeaderMask(false);
            }
        });
    });

    $('.js-header-mask').on('click', function () {
        Amisco.Common.HeaderMask(false);
        Amisco.Common.HideSubmenus();
    });

    Amisco.Common.initMobileNav();
};

$(document).init('ready', Amisco.Common.init);